import { unreachable } from '../utils/unreachable';

export enum Repeat {
  NoRepeat = 0,
  Daily = 6,
  Weekdays = 999,
  Weekly = 2,
  BiWeekly = 3,
  Monthly = 4,
  Quarterly = 5,
  Yearly = 7,
}

export function getRepeatLabel(repeat: Repeat, t: (key: string) => string): string {
  switch (repeat) {
    case Repeat.NoRepeat:
      return t('No repeat');
    case Repeat.Daily:
      return t('Daily');
    case Repeat.Weekdays:
      return t('Daily (weekdays only)');
    case Repeat.Weekly:
      return t('Weekly');
    case Repeat.BiWeekly:
      return t('Bi-weekly');
    case Repeat.Monthly:
      return t('Monthly');
    case Repeat.Quarterly:
      return t('Quarterly');
    case Repeat.Yearly:
      return t('Yearly');
    default:
      return unreachable(repeat);
  }
}

export enum TimeUnit {
  Days = 1,
  Weeks = 2,
  Months = 3,
  Quarters = 6,
  Years = 4,
}

export function getTimeUnitLabel(repeat: TimeUnit, t: (key: string) => string): string {
  switch (repeat) {
    case TimeUnit.Days:
      return t('Days');
    case TimeUnit.Weeks:
      return t('Weeks');
    case TimeUnit.Months:
      return t('Months');
    case TimeUnit.Quarters:
      return t('Quarters');
    case TimeUnit.Years:
      return t('Years');
    default:
      return unreachable(repeat);
  }
}
